import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {FileUploadRes, MediaType} from '@yasc/yasc-material-components';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

declare type usageType = "add" | 'display'
@Component({
    selector: 'cp-attachment-item',
    templateUrl: './attachment-item.component.html',
    styleUrl: './attachment-item.component.scss',
    standalone: false
})
export class AttachmentItemComponent {
    @Input() fileUpload!:FileUploadRes
    @Input() usageType:usageType = "display"
    @Output() remove:EventEmitter<void> = new EventEmitter()

    constructor(
        @Inject(L10N_LOCALE) public locale: L10nLocale,) {
    }

    iconName:() => string = () => {
        switch (this.fileUpload.type){
            case MediaType.Document:
                return 'description';
            case MediaType.LicenseAgreement:
                return '';
            case MediaType.ProductArtifact:
                return '';
            case MediaType.Receipt:
                return 'receipt_long';
            case MediaType.Signature:
                return 'contact_page';
            case MediaType.Workflow:
                return '';
            default:
                return 'image';
        }
    }
}
